"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PreconfiguredFramesWidget_1 = __importDefault(require("./PreconfiguredFramesWidget"));
exports.default = PreconfiguredFramesWidget_1.default;
